import { useState } from "react";

import { Meter, MeterFieldProps } from "../../../types/salesDocuments.types";
import { MeterContextType, useMeterContext } from "../meterContext";

export const MeterIdComponent: React.FC<MeterFieldProps> = ({ meter, readOnly, hidden }) => {
  const ctx = useMeterContext();
  const [loading, setLoading] = useState<boolean>(false);
  const [meterIdIsInvalid, setMeterIdIsInvalid] = useState<boolean>(false);

  const invalidMeter = (meter: Meter, ctx: MeterContextType) => {
    return (
      (meter.fuelType === "electricity" && ctx.mprn !== "") ||
      (meter.fuelType === "gas" && (ctx.mpanTopLine !== "" || ctx.mpanBottomLine !== ""))
    );
  };
  if (hidden) return null;

  return (
    <div className="sales-doc-field mb-3">
      <label htmlFor={`zoho-meter-${meter.id.toString()}`} className="form-label">
        Zoho Meter Id
      </label>
      <div className="input-group">
        <input
          type="text"
          id={`zoho-meter-${meter.id.toString()}`}
          className="form-control"
          minLength={18}
          maxLength={18}
          required
          value={ctx.meterId}
          readOnly={readOnly}
          onChange={(e) => {
            ctx.setMeterId(e.target.value);
          }}
        />
        <button
          type="button"
          disabled={loading}
          className="sales-doc-btn-secondary"
          onClick={() => {
            void (async () => {
              // Reset one shot state so we can update consumption again
              ctx.setTotalConsumption("0");
              ctx.setOneShotConsumptionUpdate(false);
              setLoading(true);
              setMeterIdIsInvalid(false);
              const success = await ctx.autofillFromApi(ctx.meterId);
              setLoading(false);
              setMeterIdIsInvalid(!success);
            })();
          }}
        >
          Auto-fill
        </button>
      </div>

      {meterIdIsInvalid && (
        <div className="alert alert-danger">⚠️ Given meter ID was not found in Zoho CRM.</div>
      )}

      {invalidMeter(meter, ctx) && (
        <div className="alert alert-warning">
          🚨 WARNING: Meter is {meter.fuelType} but was detected as different fuel type.
        </div>
      )}

      {loading && (
        <div className="d-flex justify-content-center mt-2">
          <div className="spinner-border spinner-border-sm text-secondary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
};
